<template>
  <div class="edit-trail">

    <h1>GALLERY EDIT</h1>

  </div>
</template>

<script>
export default {
  name: 'EditTrail',
  props: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.edit-trail {
  background-color: white;
  color: black;
  height: 100%;
  width: 100%;
}
</style>